import {createWebHashHistory, createRouter} from "vue-router";
import { executeJson, flocker } from "@/api";

// ===== AUTH =====
import Login from "@/components/Login.vue";
import Register from "@/components/Register.vue";
import ResetPasswordPage from "@/components/ResetPasswordPage.vue";

// ===== DASHBOARD =====
import Dashboard from "@/components/Dashboard.vue";

// ===== LANDING =====
import LandingPage from "@/components/flockr-marketplace/LandingPage.vue";

// ===== MARKETPLACE - BROWSING & DISCOVERY =====
import MarketplaceHome from "@/components/flockr-marketplace/MarketplaceHome.vue";
import ListingSearchResults from "@/components/flockr-marketplace/ListingSearchResults.vue";
import ListingDetail from "@/components/flockr-marketplace/ListingDetail.vue";
import SellerProfile from "@/components/flockr-marketplace/SellerProfile.vue";
import CategoryBrowse from "@/components/flockr-marketplace/CategoryBrowse.vue";
import SellerVerificationPage from "@/components/flockr-marketplace/SellerVerificationPage.vue";



// ===== MARKETPLACE - SELLING / LISTING MANAGEMENT =====
import CreateListingPage from "@/components/flockr-marketplace/CreateListingPage.vue";
import EditListingPage from "@/components/flockr-marketplace/EditListingPage.vue";
import MyListingsPage from "@/components/flockr-marketplace/MyListingsPage.vue";
import ListingPerformance from "@/components/flockr-marketplace/ListingPerformance.vue";

// ===== MARKETPLACE - BUYER ACTIONS =====
import SavedListingsPage from "@/components/flockr-marketplace/SavedListingsPage.vue";
import SavedSearchesPage from "@/components/flockr-marketplace/SavedSearchesPage.vue";
import MakeOfferPage from "@/components/flockr-marketplace/MakeOfferPage.vue";
import MyOffersPage from "@/components/flockr-marketplace/MyOffersPage.vue";

// ===== MARKETPLACE - AGGREGATOR / BUY REQUESTS =====
import BuyRequestsBoard from "@/components/flockr-marketplace/BuyRequestsBoard.vue";
import CreateBuyRequest from "@/components/flockr-marketplace/CreateBuyRequest.vue";
import BuyRequestDetail from "@/components/flockr-marketplace/BuyRequestDetail.vue";
import MyBuyRequests from "@/components/flockr-marketplace/MyBuyRequests.vue";
import SupplierNetworkPage from "@/components/flockr-marketplace/SupplierNetworkPage.vue";
import Cart from "@/components/flockr-marketplace/Cart.vue";
import CartCheckout from "@/components/flockr-marketplace/CartCheckout.vue";


// ===== ORDERS & TRANSACTIONS =====
import CheckoutPage from "@/components/flockr-orders/CheckoutPage.vue";
import OrdersPage from "@/components/flockr-orders/OrdersPage.vue";
import OrderDetail from "@/components/flockr-orders/OrderDetail.vue";
import EscrowDashboard from "@/components/flockr-orders/EscrowDashboard.vue";
import WalletPage from "@/components/flockr-orders/WalletPage.vue";
import DisputePage from "@/components/flockr-orders/DisputePage.vue";
import ReviewsPage from "@/components/flockr-orders/ReviewsPage.vue";

// ===== MESSAGING & NOTIFICATIONS =====
import MessagesInbox from "@/components/flockr-messaging/MessagesInbox.vue";
import ChatThread from "@/components/flockr-messaging/ChatThread.vue";
import NotificationsPage from "@/components/flockr-messaging/NotificationsPage.vue";

// ===== FLOCKER ADMIN =====
import AdminDashboard from "@/components/flockr-admin/AdminDashboard.vue";




// ===== FARM MANAGEMENT =====
import FarmDashboard from "@/components/flockr-farm/FarmDashboard.vue";
import AnimalDetail from "@/components/flockr-farm/AnimalDetail.vue";
// import AnimalProfile from "@/components/flockr-farm/AnimalProfile.vue";
// import HealthRecords from "@/components/flockr-farm/HealthRecords.vue";

// ===== VET SERVICES =====
import VetDirectory from "@/components/flockr-vet/VetDirectory.vue";
import VetProfile from "@/components/flockr-vet/VetProfile.vue";
import VetDashboard from "@/components/flockr-vet/VetDashboard.vue";
import VetConsultation from "@/components/flockr-vet/VetConsultation.vue";
import AISymptomCheck from "@/components/flockr-vet/AISymptomCheck.vue";

// ===== TRANSPORT =====
import TransportDirectory from "@/components/flockr-transport/TransportDirectory.vue";
import TransporterDashboard from "@/components/flockr-transport/TransporterDashboard.vue";
import TransporterProfile from "@/components/flockr-transport/TransporterProfile.vue";
import TripDetail from "@/components/flockr-transport/TripDetail.vue";
import MyTransportBookings from "@/components/flockr-transport/MyTransportBookings.vue";

// ===== INSURANCE =====
import InsurancePage from "@/components/flockr-insurance/InsurancePage.vue";

// ===== MARKET INTELLIGENCE =====
import MarketIntelligence from "@/components/flockr-market/MarketIntelligence.vue";
import MarketReportDetail from "@/components/flockr-market/MarketReportDetail.vue";

// ===== COMMUNITY =====
import ForumPage from "@/components/flockr-community/ForumPage.vue";
import ForumTopicDetail from "@/components/flockr-community/ForumTopicDetail.vue";
import LearningHub from "@/components/flockr-community/LearningHub.vue";
import ArticleDetail from "@/components/flockr-community/ArticleDetail.vue";

// ===== PRODUCTS / AGRO-INPUTS =====
import AgroInputShop from "@/components/flockr-products/AgroInputShop.vue";
import ProductDetail from "@/components/flockr-products/ProductDetail.vue";
import MyProductsPage from "@/components/flockr-products/MyProductsPage.vue";
import CreateProductPage from "@/components/flockr-products/CreateProductPage.vue";
import SellerDeliverySettings from "@/components/flockr-products/SellerDeliverySettings.vue";

// ===== USERS & SETTINGS =====
import MyProfile from "@/components/flockr-users/MyProfile.vue";
import TermsPage from "@/components/flockr-legal/TermsPage.vue";


const routes = [



    // ===== PUBLIC ROUTES =====
    {
        path: "/",
        name: "landing",
        component: LandingPage,
        meta: { public: true }
    },
    {
        path: "/login",
        name: "login",
        component: Login,
        meta: { public: true }
    },

    {
        path: "/register",
        name: "register",
        component: Register,
        meta: { public: true }
    },

    {
        path: "/reset-password",
        name: "reset-password",
        component: ResetPasswordPage,
        meta: { public: true }
    },

    // ===== DASHBOARD =====
    {
        path: "/dashboard",
        name: "dashboard",
        component: Dashboard,
        meta: { public: false }
    },

    // ===== MARKETPLACE - BROWSING & DISCOVERY =====
    {
        path: "/marketplace",
        name: "marketplace",
        component: MarketplaceHome,
        meta: { public: true }
    },

    {
        path: "/marketplace/search",
        name: "marketplace-search",
        component: ListingSearchResults,
        meta: { public: true }
    },

    {
        path: "/marketplace/listing/:id",
        name: "listing-detail",
        component: ListingDetail,
        meta: { public: true }
    },

    {
        path: "/marketplace/seller/:id",
        name: "seller-profile",
        component: SellerProfile,
        meta: { public: true }
    },

    {
        path: "/marketplace/category/:slug",
        name: "category-browse",
        component: CategoryBrowse,
        meta: { public: true }
    },
    { path: "/verification", name: "verification", component: SellerVerificationPage, meta: { public: false } },

    // ===== MARKETPLACE - SELLING / LISTING MANAGEMENT =====
    {
        path: "/sell/create",
        name: "create-listing",
        component: CreateListingPage,
        meta: { public: false }
    },
    {
        path: "/sell/edit/:id",
        name: "edit-listing",
        component: EditListingPage,
        meta: { public: false }
    },

    {
        path: "/my-listings",
        name: "my-listings",
        component: MyListingsPage,
        meta: { public: false }
    },

    {
        path: "/my-listings/performance/:id",
        name: "listing-performance",
        component: ListingPerformance,
        meta: { public: false }
    },

    // ===== MARKETPLACE - BUYER ACTIONS =====
    {
        path: "/marketplace/saved",
        name: "saved-listings",
        component: SavedListingsPage,
        meta: { public: false }
    },

    {
        path: "/marketplace/saved-searches",
        name: "saved-searches",
        component: SavedSearchesPage,
        meta: { public: false }
    },

    {
        path: "/marketplace/offer/:listingId",
        name: "make-offer",
        component: MakeOfferPage,
        meta: { public: false }
    },

    {
        path: "/my-offers",
        name: "my-offers",
        component: MyOffersPage,
        meta: { public: false }
    },

    // ===== MARKETPLACE - AGGREGATOR / BUY REQUESTS =====
    {
        path: "/marketplace/buy-requests",
        name: "buy-requests",
        component: BuyRequestsBoard,
        meta: { public: true }
    },

    {
        path: "/marketplace/buy-requests/create",
        name: "create-buy-request",
        component: CreateBuyRequest,
        meta: { public: false }
    },

    {
        path: "/marketplace/buy-requests/:id",
        name: "buy-request-detail",
        component: BuyRequestDetail,
        meta: { public: true }
    },

    {
        path: "/my-buy-requests",
        name: "my-buy-requests",
        component: MyBuyRequests,
        meta: { public: false }
    },

    {
        path: "/checkout/:offerId",
        name: "checkout",
        component: CheckoutPage,
        meta: { public: false }
    },

    {
        path: "/marketplace/suppliers",
        name: "supplier-network",
        component: SupplierNetworkPage,
        meta: { public: false }
    },

    // Cart
    { path: "/cart", name: "cart", component: Cart, meta: { public: false } },
    { path: "/cart/checkout", name: "cart-checkout", component: CartCheckout, meta: { public: false } },

    // Vet Services
    { path: "/vets", name: "vet-directory", component: VetDirectory, meta: { public: true } },
    { path: "/vet/:vetUserId", name: "vet-profile", component: VetProfile, meta: { public: true } },
    { path: "/vet/dashboard", name: "vet-dashboard", component: VetDashboard, meta: { public: false } },
    { path: "/vet/consultation/:consultationId", name: "vet-consultation", component: VetConsultation, meta: { public: false } },
    { path: "/vet/ai-check", name: "ai-symptom-check", component: AISymptomCheck, meta: { public: false } },

    // Transport & Logistics — literal paths first so they beat the :transporterId param match
    { path: "/transport", name: "transport-directory", component: TransportDirectory, meta: { public: true } },
    { path: "/transport/dashboard", name: "transporter-dashboard", component: TransporterDashboard, meta: { public: false } },
    { path: "/transport/trip/:id", name: "trip-detail", component: TripDetail, meta: { public: false } },
    { path: "/my-transports", name: "my-transports", component: MyTransportBookings, meta: { public: false } },
    { path: "/transport/:transporterId", name: "transporter-profile", component: TransporterProfile, meta: { public: true } },

    // Insurance
    { path: "/insurance", name: "insurance", component: InsurancePage, meta: { public: false } },

    // Market Intelligence — public so non-logged-in users can browse prices + reports
    { path: "/market", name: "market-intel", component: MarketIntelligence, meta: { public: true } },
    { path: "/market/report/:idOrSlug", name: "market-report", component: MarketReportDetail, meta: { public: true } },

    // Agro-Input Shop — public catalogue, login-gated checkout via the cart
    { path: "/shop", name: "agro-shop", component: AgroInputShop, meta: { public: true } },
    { path: "/shop/product/:idOrSlug", name: "product-detail", component: ProductDetail, meta: { public: true } },

    // Agro-Input Shop — seller side
    { path: "/sell/products", name: "my-products", component: MyProductsPage, meta: { public: false } },
    { path: "/sell/product/create", name: "product-create", component: CreateProductPage, meta: { public: false } },
    { path: "/sell/product/edit/:id", name: "product-edit", component: CreateProductPage, meta: { public: false } },
    { path: "/sell/delivery", name: "seller-delivery", component: SellerDeliverySettings, meta: { public: false } },

    // Community & Learning Hub — public reading; posting requires login (handled in-page)
    { path: "/learn", name: "learning-hub", component: LearningHub, meta: { public: true } },
    { path: "/learn/:idOrSlug", name: "article-detail", component: ArticleDetail, meta: { public: true } },
    { path: "/forum", name: "forum", component: ForumPage, meta: { public: true } },
    { path: "/forum/:id", name: "forum-topic", component: ForumTopicDetail, meta: { public: true } },

    // Orders & Transactions
    { path: "/orders", name: "orders", component: OrdersPage, meta: { public: false } },
    { path: "/orders/:id", name: "order-detail", component: OrderDetail, meta: { public: false } },
    { path: "/escrow", name: "escrow-dashboard", component: EscrowDashboard, meta: { public: false } },
    { path: "/me", name: "my-profile", component: MyProfile, meta: { public: false } },
    { path: "/terms", name: "terms", component: TermsPage, meta: { public: true } },
    { path: "/wallet", name: "wallet", component: WalletPage, meta: { public: false } },
    { path: "/messages", name: "messages", component: MessagesInbox, meta: { public: false } },
    { path: "/messages/:id", name: "chat-thread", component: ChatThread, meta: { public: false } },
    { path: "/notifications", name: "notifications", component: NotificationsPage, meta: { public: false } },
    { path: '/dispute/:id', component: DisputePage },
    { path: '/disputes', component: DisputePage },
    { path: '/reviews', component: ReviewsPage},

    //FLOCKER ADMIN — locked behind admin/super_admin role.
    // Server-side assertAdmin() in index.php is the real defence; this guard is the UX layer.
    {
        path: "/admin",
        name: "admin",
        component: AdminDashboard,
        meta: { requiresAdmin: true }
    },



    // Farm Management
    {
        path: '/farm',
        name: 'FarmDashboard',
        component: FarmDashboard,
        meta: { requiresAuth: true }
    },
    {
        path: '/farm/animal/:id',
        name: 'AnimalDetail',
        component: AnimalDetail,
        meta: { requiresAuth: true }
    },


];

const router = createRouter({
    history: createWebHashHistory(),
    routes
});


let userActivityTimer;

function clientHasAdminRole() {
    var roles = [];
    try { roles = JSON.parse(sessionStorage.getItem("userRoles") || "[]"); } catch (e) { /* fall through */ }
    return roles.indexOf("admin") > -1 || roles.indexOf("super_admin") > -1;
}

// Re-fetch the user's roles + admin module permissions from the server. Keeps
// sessionStorage fresh in case roles were changed in another tab (or by another
// super_admin) during this session.
async function refreshRolesFromServer() {
    var userId = sessionStorage.getItem("userId");
    if (!userId) return null;
    try {
        var r = await executeJson({ function: "getMyRoles", userId: userId }, flocker);
        if (r && r.data && r.data.success) {
            var d = r.data.data || {};
            var roles = d.roles || [];
            sessionStorage.setItem("userRoles", JSON.stringify(roles));
            sessionStorage.setItem("adminModules", JSON.stringify(d.adminModules || []));
            return d;
        }
    } catch (e) { /* offline / network — fall back to cached */ }
    return null;
}

router.beforeEach(async (to, from, next) => {
    clearTimeout(userActivityTimer);

    // Public routes: free pass
    if (to.meta.public) { next(); return; }

    // Login required
    if (!sessionStorage.getItem("isLoggedIn")) { next("/login"); return; }

    // Admin gate: client check first (fast), server reverify if cache is empty/stale
    if (to.meta.requiresAdmin) {
        if (!clientHasAdminRole()) {
            var fresh = await refreshRolesFromServer();
            if (!fresh || !fresh.isAdmin) {
                alert("This area is for Flockr admins only.");
                next("/dashboard");
                return;
            }
        }
    }

    next();

    userActivityTimer = setTimeout(() => {
        sessionStorage.removeItem("isLoggedIn");
        router.push("/login");
    }, 10 * 60 * 1000);
});

function handleUserActivity() {
    // Only track activity if user is logged in
    if (!sessionStorage.getItem("isLoggedIn")) return;

    clearTimeout(userActivityTimer);
    userActivityTimer = setTimeout(() => {
        sessionStorage.removeItem("isLoggedIn");
        router.push("/login");
    }, 10 * 60 * 1000);
}

document.addEventListener("mousemove", handleUserActivity);
document.addEventListener("keypress", handleUserActivity);

export default router;